import React, {Component} from 'react';
import {connect} from 'react-redux';

class Report extends Component {
    render() {
        return (
            <div>
                <div id="print-mount"/>
                <div id="react-no-print">
                    <h2 className="header-h2">CHRISTCHURCH AIRPORT</h2>
                    <h3 className="header-h3">Engine Testing Management System</h3>
                </div>

                <div className="iframe-container">
                    <iframe
                        src="https://datastudio.google.com/embed/reporting/374851cc-faeb-497c-af76-b63149e5b999/page/0sreB"
                        frameBorder="0" allowFullScreen/>
                </div>
            </div>
        )
    }
}

export default connect()(Report)


// WEBPACK FOOTER //
// ./src/components/Report.jsx